<template>
  <v-card tile>
    <v-card-title class="py-2" @click="show = !show" style="cursor: pointer;">
      <h3>{{instance.title}}</h3>
      <v-spacer></v-spacer>
      <v-btn icon>
        <v-icon>{{ show ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</v-icon>
      </v-btn>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text v-show="show">
      <v-layout>
        <v-flex xs1 font-weight-bold class="py-2">Id</v-flex>
        <v-flex xs6 font-weight-bold class="py-2">Input</v-flex>
        <v-flex xs6 font-weight-bold class="py-2">Output</v-flex>
      </v-layout>

      <v-layout v-for="item in routing_table" :key="item.out_id" style="border-bottom: 1px solid hsla(0,0%,100%,.12);">
        <v-flex xs1 class="py-2">{{parseInt(item.out_id) + 1}}</v-flex>
        <v-flex xs6 class="py-2">
          <v-autocomplete single-line height="20" :value="item.in_id" hide-details class="pa-0 ma-0" v-bind:items="inputs" placeholder="Input" item-text="name" item-value="id" label="Input" @change="change_route(item,$event)"></v-autocomplete>
        </v-flex>
        <v-flex xs6 class="py-2">{{item.out_label}}</v-flex>
      </v-layout>
    </v-card-text>
  </v-card>
</template>

<script>
import InstanceModel from '@/models/instance.js'

export default {
  props: ['id'],
  data() {
    var ch = this.$cloudserver.channel("instances:status:"+this.id);
    return {
      show: false,
      ws_channel: ch
    }
  },
  created() {
    this.ws_channel.join();
  },
  computed: {
    stats() {
      return this.ws_channel.data;
    },
    instance () {
			return InstanceModel.instance_by_id(this.id);
		},
    routing_table () {
      var in_labels = _.get(this.stats, "instance.input_labels");
      var out_labels = _.get(this.stats, "instance.output_labels");
      return _.map(_.get(this.stats, "instance.output_routing", {}), (in_id, out_id) => {
        return {
          in_id: in_id,
          in_label: in_labels[in_id],
          out_id: out_id,
          out_label: out_labels[out_id]
        }
      })
    },
    inputs () {
      return _.map(_.get(this.stats, "instance.input_labels"), (inp,id) => { return {name: (parseInt(id)+1) + ": " + inp, id: id} });
    }
  },
  methods: {
    change_route(item, in_id) {
      if(item.in_id != in_id) {
        var self = this;
        InstanceModel.send_command_to_external_device(this.instance, "change-route", {in_id: in_id, out_id: item.out_id}, () => {}, () => {});
      }
    }
  }
}
</script>
